export const zhProduct = {
  "product.activeRevenuePolicies": "生效中的收益策略",
  "product.assetCount": "{{count}} 种资产",
  "product.blockNumber": "区块 {{block}}",
  "product.bondingCurve": "联合曲线",
  "product.boundReferrerInviteCode": "已绑定邀请人的邀请码",
  "product.cannotBindOwnInviteCode":
    "不能绑定自己的邀请码，请输入其他用户的邀请码。",
  "product.claim": "领取",
  "product.confirming": "确认中…",
  "product.creatorLaunches": "创作者发行项目",
  "product.creatorShareValue": "创作者分成 {{percent}}%",
  "product.noCreatorShare": "未选择创作者分成",
  "product.extendedInvites": "扩展邀请",
  "product.graduationPoints": "毕业积分",
  "product.inviteCodeUnavailable": "暂无邀请码",
  "product.inviteInputPlaceholder": "例如：KKTSFR37 或粘贴邀请链接",
  "product.latestApiData": "账户 API 最新数据",
  "product.launchRevenueProjects": "Launch 收益项目",
  "product.myRewardTokens": "我的收益代币",
  "product.chooseTokenToViewRewards": "选择代币，查看并领取对应收益。",
  "product.rewardTokenList": "收益代币",
  "product.rewardRulesSummary": "收益规则与预计金额说明",
  "product.launchRevenueUnavailable": "暂时无法从当前合约读取 Launch 收益。",
  "product.levelOneReferrals": "一级邀请",
  "product.levelTwoPlusReferrals": "二级及以上邀请",
  "product.activitySignIn": "您还未登录，登录后即可查看账户记录。",
  "product.noActivityRecords": "暂无符合条件的积分记录",
  "product.noCreatorLaunches": "当前钱包没有可领取的创作者收益或持币分红。",
  "product.oneClickClaimHint":
    "可用收益尚未入账，点击领取可按当前钱包权限尝试结算。",
  "product.noVestingRecords": "暂无释放记录。",
  "product.nothingToClaim": "暂无可领",
  "product.pendingDistribution": "待分配收益",
  "product.pendingFeesValue": "待分配 {{amount}} {{symbol}}",
  "product.portfolioApiUnavailable": "账户数据暂时不可用",
  "product.pointsRanking": "积分排行榜",
  "product.rankingSettledPoints": "已结算积分 · 前 100 名",
  "product.rankingRank": "排名",
  "product.rankingYou": "你",
  "product.rankingSignIn": "登录后查看积分排行榜。",
  "product.rankingUnavailable": "积分排行榜暂时不可用。",
  "product.rankingEmpty": "暂无上榜用户。",
  "product.revenueSignIn": "您还未登录，登录后即可查看和领取收益。",
  "product.referralNetwork": "邀请网络",
  "product.referralPoints": "邀请积分",
  "product.referrerAlreadyBound": "已绑定邀请人",
  "product.referrerBindFailed": "邀请人绑定失败",
  "product.revenueClaimConfirmed": "处理完成，可领取的本人收益已转入钱包。",
  "product.revenueClaimFailed": "收益领取未完成",
  "product.projectRevenueClaimConfirmed":
    "{{symbol}} 领取交易已确认，收益数据正在刷新。",
  "product.projectRevenueClaimFailed": "{{symbol}} 收益领取未完成",
  "product.projectRevenueClaimRequiresSettlement":
    "{{symbol}} 收益尚未完成归集",
  "product.revenueClaimRequiresSettlement":
    "“本次预计新增”尚未进入可领取余额。请先点击项目顶部的“结算并归集”，归集确认并刷新后再领取。",
  "product.revenueClaimRetry":
    "交易模拟或链上执行失败，请刷新收益数据并检查钱包状态后重试。",
  "product.projectRevenueGasLimitReduced":
    "钱包最终提交的 Gas Limit（{{submitted}}）低于页面请求值（{{requested}}），部分领取动作未执行。请确认钱包未自动降低 Gas 后重试。",
  "product.settleProjectRevenue": "结算并归集 {{symbol}}",
  "product.normalizeProjectFees": "兑换手续费",
  "product.feeNormalizationRequiresMigration": "项目毕业后才能兑换外盘手续费。",
  "product.feeNormalizationRequired": "需先兑换手续费",
  "product.pendingTokenFeeBreakdown":
    "已归集 {{collected}} · 收益源 {{source}}",
  "product.feeNormalizationConfirmed":
    "{{symbol}} 手续费已兑换为配对资产，链上数据正在刷新。",
  "product.feeNormalizationFailed": "{{symbol}} 手续费兑换未完成",
  "product.settlementReadiness": "归集条件",
  "product.settlementReady": "可执行归集",
  "product.settlementIdle": "暂无待归集收益",
  "product.accruedSettlementFees": "收益源待归集",
  "product.pendingQuoteFees": "结算池待分配",
  "product.pendingTokenFees": "Meme Token 待分配",
  "product.pendingStrategyModules": "待处理策略 / 全部策略",
  "product.projectRevenueSettlementConfirmed":
    "{{symbol}} 收益已完成结算归集，可领取金额正在刷新。",
  "product.projectRevenueSettlementFailed": "{{symbol}} 收益归集未完成",
  "product.projectRevenueAtomicSettlementFailed":
    "归集模拟或链上执行失败，可能是链上状态已变化，或当前步骤暂不可执行。请刷新后重试。",
  "product.projectStrategyOperations": "策略执行",
  "product.projectStrategyOperationsDescription":
    "Token 毕业并完成 V4 迁移后，可在此查看和执行项目策略。",
  "product.revenueInnerMarketStage": "内盘阶段",
  "product.revenueAwaitingGraduation": "毕业后开放",
  "product.revenueInnerMarketNoticeTitle": "内盘阶段暂不执行项目策略",
  "product.revenueInnerMarketNoticeDescription":
    "内盘仍支持结算并归集手续费，平台份额正常记账，项目方策略份额锁定等待毕业。Token 毕业并完成 V4 迁移后，才会开放外盘回购、分红奖励兑换和个人收益领取。",
  "product.lockedProjectFees": "项目份额已锁定",
  "product.settledFeesTotal": "累计已结算",
  "product.onchainState": "链上实时状态",
  "product.dividendRewardConversion": "分红奖励兑换",
  "product.convertDividendReward": "兑换奖励",
  "product.dividendConversionDescription":
    "将已归集的分红预算兑换为 {{asset}} 并存入策略奖励库存，不会转入执行钱包。",
  "product.dividendConversionConfirmed":
    "{{symbol}} 分红奖励兑换成功，链上数据正在刷新。",
  "product.dividendConversionFailed": "{{symbol}} 分红奖励兑换失败",
  "product.requestingExecutionQuote": "正在获取报价",
  "product.validatingExecutionQuote": "正在校验链上状态",
  "product.simulatingTransaction": "正在模拟交易",
  "product.awaitingWalletConfirmation": "等待钱包签名",
  "product.confirmingOnchainTransaction": "等待链上确认",
  "product.executionQuoteTimeout": "报价服务响应超时，请稍后重新获取报价。",
  "product.executionQuoteExpired": "报价已过期，请重新发起操作获取最新报价。",
  "product.rewardPoolUnavailable":
    "当前计价资产尚未配置可用的奖励兑换池，请联系平台完成池配置。",
  "product.executionQuoteValidationFailed":
    "报价与当前链上配置或安全限制不一致，已阻止提交交易。",
  "product.innerBuyback": "内盘回购销毁",
  "product.executeInnerBuyback": "执行内盘回购",
  "product.innerBuybackDescription":
    "使用策略预算从联合曲线回购 {{symbol}} 并在同一笔交易中销毁，不会转入执行钱包。",
  "product.innerBuybackConfirmed":
    "{{symbol}} 内盘回购销毁成功，链上数据正在刷新。",
  "product.innerBuybackFailed": "{{symbol}} 内盘回购销毁失败",
  "product.executeOuterBuyback": "执行外盘回购",
  "product.outerBuybackDescription":
    "使用策略预算从毕业后的 V4 交易池回购 {{symbol}} 并在同一笔交易中销毁，不会转入执行钱包。",
  "product.outerBuybackConfirmed":
    "{{symbol}} 外盘回购销毁成功，链上数据正在刷新。",
  "product.outerBuybackFailed": "{{symbol}} 外盘回购销毁失败",
  "product.buybackAndBurn": "回购与销毁",
  "product.buybackMarketInner": "内盘",
  "product.buybackMarketOuter": "外盘",
  "product.strategyBudget": "策略预算",
  "product.buybackBudget": "可用回购预算",
  "product.buybackExecutionLimit": "本次可投入",
  "product.buybackTotalSpent": "累计投入",
  "product.buybackTotalBurned": "累计销毁",
  "product.buybackStatusReady": "可执行",
  "product.buybackStatusConnectWallet": "请连接钱包",
  "product.buybackStatusNoPermission": "无执行权限",
  "product.buybackStatusDisabledAtLaunch": "发行时未开启",
  "product.buybackStatusOuterUnavailable": "外盘暂未开放",
  "product.buybackStatusOuterUnavailableDescription":
    "该项目已进入外盘；当前仅保留回购信息展示，外盘回购入口后续开放。",
  "product.buybackStatusTradingUnavailable": "交易未开放",
  "product.buybackStatusWaitingBudget": "等待预算",
  "product.buybackStatusLimitUnavailable": "额度未就绪",
  "product.walletRequestRejected": "你已取消钱包请求。",
  "product.strategyOperationRetry":
    "报价、交易模拟或链上执行未完成，请刷新链上数据后重试。",
  "product.claimCreatorRevenue": "领取创作者收益",
  "product.claimDividendRevenue": "领取持币分红",
  "product.creatorRevenueClaimConfirmed": "{{symbol}} 创作者收益已转入钱包。",
  "product.dividendRevenueClaimConfirmed": "{{symbol}} 持币分红已转入钱包。",
  "product.claimProjectRevenue": "领取 {{symbol}} 收益",
  "product.claimSuccessful": "领取成功",
  "product.creatorRevenueEstimate": "创作者收益",
  "product.creatorRevenueDescription": "发行创建者按策略比例获得的交易收益。",
  "product.dividendRevenueDescription": "根据该 Meme 持币权重和分红快照计算。",
  "product.revenueEstimateDisclaimer":
    "本次预计可领取 = 当前可领取 + 本次操作预计新增。创作者新增收益需先归集；分红奖励库存可在领取时生成新快照。未扣除 Gas，实际金额以链上执行为准。",
  "product.revenueEstimateIncomplete":
    "部分策略预估不完整；未显示的收益不能视作零。",
  "product.revenueEstimateUnavailable":
    "合约预估暂不可用；下方仅显示已入账的可领取金额。",
  "product.revenueEstimatedTotal": "本次预计可领取",
  "product.revenueCurrentClaimable": "当前可领取",
  "product.creatorRevenueCurrentClaimableShared": "当前可领取（同资产累计）",
  "product.creatorRevenueEstimatedAdditional": "归集后预计新增",
  "product.dividendRevenueEstimatedAdditional": "本次快照预计新增",
  "product.revenueHistoricalClaimed": "历史累计已领取",
  "product.revenueAmountPending": "链上结算后确定",
  "product.revenueReady": "可领取",
  "product.revenueAwaitingSettlement": "待结算",
  "product.revenueAwaitingConversion": "待兑换奖励",
  "product.revenueRouterUnavailable":
    "当前 Factory 尚未接入最新版收益合约，暂不可发行或归集。",
  "product.weightedDividend": "按持币权重分红",
  "product.dividendAwaitingSnapshot": "领取时可生成新的分红快照",
  "product.revenuePolicyDisabled": "收益策略未启用",
  "product.settlementAsset": "结算资产：{{asset}}",
  "product.settlementAssetLabel": "到账资产",
  "product.singleProjectTransaction": "单个 Meme · 1 笔交易",
  "product.revenueProjectClaimNotice":
    "内盘阶段仅开放可执行的收益归集；项目策略份额会锁定等待毕业。Token 毕业并完成 V4 迁移后，才会展示外盘回购、分红奖励兑换和个人收益领取入口。",
  "product.revenueProjectCount": "{{count}} 个收益项目",
  "product.onchainExecutionDetails": "链上执行详情",
  "product.projectContract": "Meme 合约",
  "product.policyVersion": "收益策略版本",
  "product.strategyCount": "项目策略数量",
  "product.transactionWillAttempt": "本次交易将依次尝试",
  "product.revenueStepCreator": "领取当前钱包的创作者收益",
  "product.revenueStepDividend": "生成可用分红快照并领取持币分红",
  "product.totalNetwork": "邀请网络总人数",
  "product.tradePoints": "交易积分",
  "product.pointsAndRewards": "积分 / 奖励预估",
  "product.pointsBreakdown": "积分构成与预计奖励",
  "product.innerMarket": "内盘交易",
  "product.outerMarket": "外盘交易",
  "product.estimatedReward": "预计奖励",
  "product.rewardEstimateNotice":
    "预计奖励会随全体积分与毕业代币总数动态变化，最终数量以活动结算结果为准。",
  "product.claimSubmittedToast": "领取交易已提交，等待确认。",
  "product.vestingClaimSubmittedToast": "释放领取已提交，等待确认。",
  "product.referrerBoundToast": "邀请人绑定已提交。",
  "product.inviteLinkCopied": "邀请链接已复制。",
  "product.contractAddressUnavailable": "OURS 合约地址尚未配置。",
  "product.129mBurned": "销毁 1.29M",
  "product.12ActiveThisWeek": "本周活跃12人",
  "product.12MonthLinearRelease": "12个月线性释放",
  "product.198mBurned": "销毁 1.98M",
  "product.24hVolume": "24小时交易量",
  "product.3Graduated": "3个已毕业",
  "product.4HoursAgo": "4小时前",
  "product.8MinutesAgo": "8分钟前",
  "product.accountActivity": "账户记录",
  "product.accountActive": "已激活",
  "product.accountApproved": "审核通过",
  "product.accountBound": "已绑定",
  "product.accountInactive": "未激活",
  "product.accountMenu": "账户菜单",
  "product.accountPending": "审核中",
  "product.accountRejected": "审核未通过",
  "product.accountUnbound": "未绑定",
  "product.allowlist": "白名单",
  "product.applicationStatus": "申请状态",
  "product.xBindingBenefitIdentity": "在 OURS 社区展示你的公开 X 身份。",
  "product.xBindingBenefitNoPosting": "OURS 无法代你发布或修改任何内容。",
  "product.xBindingBenefitPublicProfile": "仅展示你的公开资料和头像。",
  "product.xBindingCancel": "取消",
  "product.xBindingCancelled": "已取消 X 授权，可在准备好后重新尝试。",
  "product.xBindingChecking": "正在检查 X 绑定状态…",
  "product.xBindingClose": "关闭 X 绑定弹窗",
  "product.xBindingConnect": "绑定 X",
  "product.xBindingConnectHint": "补充公开社交身份",
  "product.xBindingConnected": "已绑定",
  "product.xBindingConsent":
    "我同意向 OURS 提供公开的 X 资料，用于账户身份展示。",
  "product.xBindingContinue": "前往 X 授权",
  "product.xBindingDescription":
    "绑定 X 账号，让你的 OURS 身份更容易被社区识别。",
  "product.xBindingDone": "完成",
  "product.xBindingExpired": "本次 X 授权已过期，请重新发起绑定。",
  "product.xBindingFailed": "绑定失败",
  "product.xBindingFailedDescription":
    "暂时无法绑定你的 X 账号，请重新发起授权。",
  "product.xBindingFinishing": "正在完成 X 绑定…",
  "product.xBindingOccupied": "已绑定到其他账户",
  "product.xBindingOccupiedDescription": "该 X 账号已经绑定到其他 OURS 账户。",
  "product.xBindingPending": "等待 X 授权",
  "product.xBindingPendingDescription":
    "请在 X 窗口完成授权；验证期间请保持当前窗口打开。",
  "product.xBindingPopupBlocked":
    "浏览器阻止了 X 授权窗口，请允许本站弹出窗口后重试。",
  "product.xBindingRetryCheck": "点击重新检查",
  "product.xBindingSucceeded": "X 账号绑定成功。",
  "product.xBindingSuccessDescription":
    "你的 X 资料已绑定，账户菜单将优先展示 X 头像。",
  "product.xBindingTitle": "绑定 X 账号",
  "product.xBindingTryAgain": "重新尝试",
  "product.xBindingUnavailable": "暂时无法读取 X 状态",
  "product.xBindingWindowClosed": "X 授权尚未完成，窗口已被关闭。",
  "product.advanced": "高级设置",
  "product.enableAdvancedSettings": "开启高级设置",
  "product.afterClose": "结束后",
  "product.afterGraduationUniswapV4PlusHookFee":
    "毕业后：Uniswap v4 + Hook 手续费。",
  "product.afterInvestment": "投入后",
  "product.aJoyfulMemeOwnedByItsContributors": "由贡献者共同拥有的欢乐 Meme。",
  "product.all": "全部",
  "product.allocationPurpose": "分配用途",
  "product.allocationRatio": "分配比例",
  "product.allocationTotal": "合计",
  "product.allocationMustTotal100": "每项须为大于 0 的整数，合计须为 100%。",
  "product.allocationScenario": "分配场景",
  "product.allocationFeeNote":
    "策略比例用于分配项目方的 {{share}}% 份额，合计必须为 100%。",
  "product.allocationSummaryBuyback":
    "你的可分配收益中，{{share}}% 用于回购，{{retained}}% 留给你自行领取。",
  "product.allocationSummaryDividend":
    "你的可分配收益中，{{share}}% 用于分红，{{retained}}% 留给你自行领取。",
  "product.allocationIsFinalisedAfterTheRoundClosesItThenUnlocks":
    "募资结束后按最终出资比例确定份额，随后自 TGE 起在12个月内持续线性释放。",
  "product.allRobinhoodChainStockTokensAndEtfsCanBeDiscovered":
    "可选资产由 Factory 链上配置决定；计价资产、毕业门槛和永久 LP 交易对将在发行时锁定。",
  "product.amount": "发送数量",
  "product.anyoneCanTriggerTheFixedBatchWithProtocolFundsThe":
    "任何人都可以使用协议资金触发固定金额回购，触发者只负责签名和 Gas。",
  "product.assetNotShown": "列表中没有？",
  "product.assets": "资产",
  "product.at100TheMarketMigratesAutomaticallyToAUniswapV4":
    "达到100%后自动迁移至 Uniswap v4 外盘池。",
  "product.at1mRaised": "募资100万",
  "product.at2mRaised": "募资200万",
  "product.attributedFromTheInvitedUsersValidVolumeAndGraduationActivity":
    "依据被邀请用户的有效交易量与毕业贡献归属。",
  "product.available": "可领取",
  "product.availableBalance": "可用余额",
  "product.awaitingConfirmation": "等待链上确认…",
  "product.backToExplore": "返回发现",
  "product.balance": "余额",
  "product.balancePercentage": "选择可用余额比例",
  "product.batchReady": "批次可触发",
  "product.bindYourReferrer": "绑定邀请人",
  "product.botServiceFee": "Bot服务费",
  "product.bubuGraduated": "推动 BUBU 毕业",
  "product.burn": "销毁",
  "product.buy": "买入",
  "product.buy2": "买入",
  "product.buyback": "回购与销毁",
  "product.buybackBurn": "回购销毁",
  "product.buybackOnly": "回购",
  "product.buybackOnlyScenario": "仅回购销毁",
  "product.buybackAndDividends": "回购销毁＋分红",
  "product.allRevenueStrategies": "Dev＋回购销毁＋分红",
  "product.buybackSubmitted": "回购已提交！",
  "product.buyOurs": "回购 OURS",
  "product.calculatedFromSuccessfulOnChainVolumeMoreContributionEarnsMore":
    "按成功链上交易量计算，贡献越多可获得更多份额。",
  "product.chain4663WalletAndBotSdk": "Chain 4663 钱包与 Bot SDK",
  "product.chainId4663RefreshedAtLaunch": "Chain ID 4663 · 发行时实时刷新",
  "product.charactersMax": "字符以内",
  "product.chooseFromEthUsdcAndApprovedTokenisedStocksOneLaunch":
    "选择 Factory 当前批准的计价资产。每次发行只能选择一种，发行后不可更换。",
  "product.chooseOneApprovedQuoteAssetTheCurveGraduationTargetAnd":
    "选择 Factory 当前批准的计价资产；内盘、毕业目标和永久 LP 交易对将在发行时锁定。",
  "product.chooseTheLpQuoteAsset": "选择 LP 配对资产",
  "product.lpPairAssetCount": "可选 {{count}} 种资产",
  "product.scrollForMoreAssets": "滚动查看更多",
  "product.claim16438Ours": "领取 16,438 OURS",
  "product.claimableCreatorFees": "可领创作者手续费",
  "product.claimableNow": "当前可领取",
  "product.claimAll": "全部领取",
  "product.claimCenter": "收益领取",
  "product.claimed": "已经领取",
  "product.claims": "收益领取",
  "product.claims2": "领取",
  "product.closeLaunchDialog": "关闭发行弹窗",
  "product.closeSendDialog": "关闭发送弹窗",
  "product.community0Pts": "社区触发 · 0积分",
  "product.communityExecution": "社区执行",
  "product.communityRound": "社区募资",
  "product.confirmed": "已确认",
  "product.connect": "登录",
  "product.connectAndContributeEth": "登录并投入 ETH",
  "product.connectContributeEthOwnTogether": "登录，投入 ETH，共同拥有。",
  "product.connectedWallet": "已登录钱包",
  "product.connectedWallet2": "已登录钱包",
  "product.connecting": "连接中…",
  "product.connectToTrade": "登录后交易",
  "product.connectWallet": "登录",
  "product.connectWalletAndReview": "登录并预览发行",
  "product.connectYourWalletToSeeContributionsFinalAllocationAndClaim":
    "登录后查看认购记录、最终份额与领取记录。",
  "product.copyAddressFailed": "钱包地址复制失败。",
  "product.copyWalletAddress": "复制钱包地址",
  "product.continuousLinearUnlockNoOneTimeCliffRelease":
    "持续线性释放，无一次性集中解锁",
  "product.contract": "合约",
  "product.contractCopied": "合约已复制 ✓",
  "product.contractInterfaces": "合约接口",
  "product.contributeAmountEth": "确认投入 {{amount}} ETH",
  "product.contributed": "累计投入",
  "product.contributeEthOnRobinhoodChainAndReceiveAProRata":
    "通过 Robinhood Chain 募资合约投入原生 ETH，每笔金额均在链上记账。",
  "product.contributionAmount": "投入数量",
  "product.contributionBecomesOwnership": "贡献者成为平台持有人",
  "product.contributionEpoch08": "贡献奖励 · 第08期",
  "product.contributionMining": "行为贡献挖矿",
  "product.contributionReward": "可领贡献奖励",
  "product.contributionSubmitted": "投入已提交 ✓",
  "product.copied": "已复制 ✓",
  "product.copyLink": "复制链接",
  "product.creatorFee": "创作者费率",
  "product.creatorFee2": "创作者费率",
  "product.creatorFeeWallet": "创作者收益钱包",
  "product.creator": "创建者",
  "product.creatorOnly": "仅 Dev",
  "product.creatorAndBuyback": "Dev＋回购销毁",
  "product.creatorAndDividends": "Dev＋分红",
  "product.creatorRevenueAllocation": "创建者收益分配",
  "product.creatorJoyLaunched": "创作者 · 发行 JOY",
  "product.creatorShareBuybackVault": "创作者份额回购金库",
  "product.current": "当前",
  "product.currentPhase": "当前阶段",
  "product.currentPrice": "当前价格",
  "product.description": "项目介绍",
  "product.dev": "Dev",
  "product.developerBuyOptional": "开发者首购 · 选填",
  "product.directInvites": "直接邀请",
  "product.disabled": "未开启",
  "product.dividends": "分红",
  "product.dividendsOnly": "仅分红",
  "product.dividendAsset": "分红资产",
  "product.dividendRules": "分红规则",
  "product.distributableRevenueRatio": "可分配收益比例",
  "product.revenueAllocation": "收益分配",
  "product.currentRevenuePolicy": "协议手续费去向",
  "product.loadingRevenuePolicy": "正在读取链上配置…",
  "product.revenuePolicyUnavailable": "链上分配配置暂不可用",
  "product.noRevenuePolicy": "尚未配置收益分配",
  "product.platformShare": "平台份额",
  "product.remainingFeeShare": "项目方份额",
  "product.remainingToGraduateLabel": "距毕业还差",
  "product.userDividends": "用户分红",
  "product.otherRevenueStrategy": "其他链上策略",
  "product.platformRevenue": "平台收益",
  "product.projectRevenueShare": "项目方份额",
  "product.projectRevenueStrategies": "项目收益策略",
  "product.platformShareHint":
    "发行后固定。可选择 30%–100%；设为 100% 时不配置任何项目策略。",
  "product.platformOnlyRevenueHint":
    "全部手续费收益归平台，本次发行不会配置项目收益策略合约。",
  "product.creatorTradeTax": "创作者交易税",
  "product.buySurcharge": "买入附加税",
  "product.revenueAllocationHint":
    "选择项目方 {{share}}% 份额的用途。下方策略比例以项目方份额为 100% 基数。",
  "product.buybackAvailabilityAfterGraduation":
    "回购仅在 Token 毕业并完成 V4 迁移后执行。内盘阶段不会执行回购，项目方回购份额将锁定等待毕业。",
  "product.dividendAvailabilityAfterGraduation":
    "持币分红仅在 Token 毕业并完成 V4 迁移后开放。内盘阶段分红份额将锁定，毕业后归集并按所选资产生成分红。",
  "product.buybackDividendAvailabilityAfterGraduation":
    "回购与持币分红均在 Token 毕业并完成 V4 迁移后开放。内盘阶段对应策略份额只累计并锁定，不会执行回购或领取分红。",
  "product.enableRevenueAllocation": "开启收益分配",
  "product.revenueAllocationEnabledSummary": "已开启 · 按合约策略分配",
  "product.revenueAllocationPlatformOnlySummary": "平台 100% · 无项目策略",
  "product.revenueAllocationSplitSummary":
    "平台 {{platform}}% · 项目方 {{project}}%",
  "product.strategyAvailabilityLoading": "正在校验链上可选收益策略…",
  "product.strategyAvailabilityReadFailed":
    "无法读取链上策略目录，请稍后重试。",
  "product.strategyUnavailable":
    "所选收益策略尚未注册、已暂停或不允许用于新发行。",
  "product.discoverLiveBondingCurvesAndGraduatedUniswapV4MarketsPaired":
    "发现实时内盘与已毕业的 Uniswap v4 市场，配对资产以 Factory 链上配置为准。",
  "product.dynamicQuote": "动态认购结果",
  "product.eachAssetIsClaimedFromItsOwnOnChainBalance":
    "不同资产按链上可领取余额分别结算。",
  "product.economicsAndOpeningBuy": "经济参数与开发者首购",
  "product.enabled": "已开启",
  "product.end": "结束",
  "product.enterACodeOrPasteTheCompleteInviteLinkBefore":
    "首次贡献前填写邀请码或粘贴完整邀请链接。",
  "product.enterAnEthAmountAbove": "请在上方输入 ETH 数量",
  "product.epoch08": "第08期",
  "product.est124800Ours": "预计回购 124,800 OURS",
  "product.estimatedAllocation": "预计份额",
  "product.estimatedOursFromThe20Pool": "预计获得 {{symbol}} · 来自20%份额池",
  "product.estimatedShareOfTotalSupply": "预计占总供应量",
  "product.estimatedUsdValue": "预计美元价值",
  "product.estReceive": "预计收到",
  "product.ethIsConvertedAtTheLiveExecutionQuoteTheDisplayed":
    "页面金额按 ETH/USDT 实时行情换算；链上实际仍投入原生 ETH。",
  "product.everyCompletedGraduationCountsMultipleSuccessfulProjectsCanEarnMultiple":
    "每个成功毕业项目都计入，可以凭多个毕业项目获得多份奖励。",
  "product.everyDayUntil20270701": "每日持续至 2027-07-01",
  "product.everyTermIsPreviewedBeforeSigningAndRemainsFixedFor":
    "所有参数在签名前预览，并在本次发行中保持固定。",
  "product.executedAtomicallyWithLaunch": "与发行交易原子执行",
  "product.invalidDeveloperBuy": "请输入有效且不小于 0 的开发者首购数量。",
  "product.initialPurchase": "首次购买",
  "product.initialPurchaseHint": "发行时可选择同步购买自己的 Token。",
  "product.curveTradingFee": "内盘交易手续费",
  "product.curveTradingFeeValue": "{{fee}}%",
  "product.curveTradingFeeHint":
    "控制联合曲线阶段每笔买卖的基础手续费，发行后固定。该设置不控制毕业后的 Pool 核心费率，当前 Pool 核心费率为 0。",
  "product.curveTradingFeeRange":
    "链上可选 {{minimum}}%–{{maximum}}%，共 {{count}} 档",
  "product.initialBuyAmount": "购买使用的配对资产数量",
  "product.initialBuyPlaceholder": "0，不进行首次购买",
  "product.initialBuyHelp":
    "留空或填 0 表示不购买；大于 0 时与发行交易原子执行，实际获得数量以签名前模拟结果为准。",
  "product.estimatedInitialBuyTokens": "预计获得 Token",
  "product.initialBuyEstimateLoading": "正在读取曲线计价参数…",
  "product.initialBuyEstimateUnavailable": "暂时无法计算预计获得数量",
  "product.initialBuyTooSmall": "购买金额过小，预计获得 0 Token",
  "product.initialBuyEstimateHint":
    "根据当前配对资产的链上联合曲线参数、手续费和可售数量计算；超出可售部分会退款。签名前会再次模拟，最终数量以交易结果为准。",
  "product.invalidSnipeTaxExemptions":
    "狙击税豁免地址必须为有效地址，且最多填写 32 个。",
  "product.explore": "发现",
  "product.explore2": "发现",
  "product.externalRouteDiscovery": "外部路由发现",
  "product.feeAllocation": "手续费分配",
  "product.feeSplitProjectPlatform": "手续费（项目 / 平台）",
  "product.feeEnforcement": "手续费执行",
  "product.feeExecutorOnline": "手续费执行器在线",
  "product.feePlusRouteExecution": "收费与路由执行",
  "product.feesBuyBackOurs": "平台手续费份额按规则回购 OURS",
  "product.feesToBuyback": "手续费用于回购",
  "product.finalTokenAllocationIsSettledProRataAgainstThe20":
    "预计 Token 份额按实时链上累计募资、平台估值与当前参考价格测算；最终份额在募资结束后结算。",
  "product.firstClaim": "首次领取",
  "product.fixedAfterLaunch": "发行后固定",
  "product.fixedBatch": "固定回购金额",
  "product.fromFundsRaised": "募资资金",
  "product.fundingStructure": "募资结构",
  "product.fundraising": "募资认购",
  "product.fundraising2": "计划募资",
  "product.fundraising3": "募资",
  "product.fundraisingAllocation": "募资释放",
  "product.fundraisingProgress": "募资进度",
  "product.fundraisingRange": "募资区间",
  "product.graduate": "毕业",
  "product.graduated": "已毕业",
  "product.graduated2": "已毕业",
  "product.graduatedTrades": "毕业后交易",
  "product.graduateToUniswapV4": "毕业进入 Uniswap v4",
  "product.graduation": "毕业进度",
  "product.graduation2": "项目毕业",
  "product.graduation3": "毕业",
  "product.graduation4": "毕业贡献",
  "product.graduation5": "毕业后",
  "product.graduationLiquidity": "毕业流动性",
  "product.graduationPool": "毕业池",
  "product.graduationProgress": "毕业进度",
  "product.graduationTargetReached": "已达到毕业目标",
  "product.graduationRoute": "毕业路由",
  "product.haveAnInviteCode": "已有邀请码？",
  "product.holders": "持币地址",
  "product.imageSelected": "图片已选择",
  "product.invitation": "邀请贡献",
  "product.invitationData": "邀请数据",
  "product.invite": "邀请",
  "product.inviteAttribution": "邀请归属",
  "product.inviteBound": "邀请绑定",
  "product.inviteCodeOrLink": "邀请码或邀请链接",
  "product.invitePoints": "邀请积分",
  "product.invites": "邀请",
  "product.inviteBinding": "邀请绑定",
  "product.joyTogether": "欢乐共享",
  "product.justNow": "刚刚",
  "product.keeperOnline": "执行器在线",
  "product.lastSweep6MinutesAgo": "上次归集于6分钟前",
  "product.launch": "发行",
  "product.launched": "邀请发行",
  "product.launchedToday": "今日发行",
  "product.launchDialogDescription":
    "完善项目资料并选择交易市场。所有关键参数都会在钱包签名前再次确认。",
  "product.launchDialogHeadline": "创建你的 Meme Token",
  "product.launchDialogKicker": "OURS 发射台 · Robinhood Chain",
  "product.launchFee": "发行费用",
  "product.launchImageHint": "PNG / JPG / GIF / BMP · 最大 5 MB",
  "product.launchMarketDescription":
    "选择一个 Factory 已批准的计价资产；发行后，内盘、毕业目标和永久流动性配对将保持不变。",
  "product.launchNeedsAttention": "完成必填信息后即可发行",
  "product.launchOnRobinhood": "在 Robinhood 链发行",
  "product.launchPreview": "实时预览",
  "product.launchProfileDescription":
    "这是用户在发现页和交易页看到的项目信息。代币名称、符号与图片为必填项。",
  "product.launchReady": "发行信息已就绪",
  "product.launchReviewReady": "发行预览已就绪",
  "product.launchToken": "发行 Token",
  "product.login": "登录",
  "product.loginAndReview": "登录并预览发行",
  "product.loggingIn": "登录中…",
  "product.linear": "线性",
  "product.linearReleaseOver12MonthsFromTge": "自 TGE 起12个月线性释放",
  "product.liquidity": "流动性",
  "product.live": "进行中",
  "product.liveLinearVest": "实时线性释放",
  "product.liveTokens": "实时 Token",
  "product.lockedForever": "永久锁定",
  "product.lpPair": "LP 交易对",
  "product.marketCap": "市值",
  "product.marketData": "行情数据",
  "product.marketLiquidity": "市场流动性建设",
  "product.marketLiquidityAndTokenMarketBuilding":
    "募资款用于市场流动性与 Token 市场建设",
  "product.marketsCurveAndUniswapV4": "个市场 · 内盘与 Uniswap v4",
  "product.memePositions": "Meme 持仓",
  "product.migrating": "毕业处理中",
  "product.minReceived": "最少收到（1% 滑点）",
  "product.monthlyUnlock12Months": "每月释放 · 12个月",
  "product.myOurs": "我的 OURS",
  "product.myOurs2": "我的",
  "product.mySubscription": "我的认购",
  "product.name": "名称",
  "product.nativeGas": "原生 Gas",
  "product.nearGraduation": "即将毕业",
  "product.netQuoteAfterAllFees": "返回扣费后净报价",
  "product.networkContribution": "邀请网络贡献",
  "product.networkVolume": "网络交易量",
  "product.newest": "最新",
  "product.noCap": "不设上限",
  "product.noContributionYet": "暂无认购记录",
  "product.noCycleCap": "不设周期上限",
  "product.now": "刚刚",
  "product.onChain": "链上",
  "product.onChainReceipts": "链上执行凭证",
  "product.oneCenterForAssetsEarningsPointsInvitationsAndVesting":
    "资产、收益、积分、邀请与私募释放统一管理。",
  "product.oneFeeLayerMultipleRoutes": "统一收费层，多种交易路由。",
  "product.oneWalletCanBindOneReferrerOnly":
    "每个钱包只能绑定一个邀请人，绑定后不可更改。",
  "product.only": "唯一资产",
  "product.openingBuyRecipient": "首购接收地址",
  "product.openingBuyUnavailable": "当前 Factory 未配置原子首购路由。",
  "product.openIntegration": "开放接入",
  "product.openWalletAccount": "打开钱包账户",
  "product.openAccountMenu": "打开 {{account}} 的账户菜单",
  "product.oursHoldings": "OURS 持仓",
  "product.oursHome": "ours 首页",
  "product.oursToken": "平台 Token",
  "product.overview": "Token 总览",
  "product.paidInTheSelectedQuoteAsset": "以所选计价资产结算",
  "product.pasteAnyRobinhoodChainStockTokenOrEtfContractThe":
    "粘贴 Robinhood Chain 上的 ERC-20 合约地址；发行流程会校验元数据、Factory 计价参数与 Registry 状态。",
  "product.pending": "待确认",
  "product.pendingExecution": "待执行资金",
  "product.permanentLiquidity": "流动性提供",
  "product.planningRange": "规划区间",
  "product.platformFees": "平台手续费",
  "product.platformTokenFundingStructureBuybackAndRobinhoodChainTradingInfrastructu":
    "平台 Token、募资结构、回购机制与 Robinhood Chain 交易基础设施。",
  "product.points": "积分",
  "product.poolLinearVesting": "份额池 · 线性释放",
  "product.portfolioValue": "资产总值",
  "product.preGraduationTrades": "内盘交易",
  "product.price": "价格",
  "product.priceImpact": "价格影响",
  "product.primaryNavigation": "主导航",
  "product.privateRoundAllocation": "私募 Token 份额",
  "product.privateVesting": "私募释放",
  "product.privyWalletsAndTradingBotsCallOursGatewayOnChain":
    "Privy 钱包和 Trading Bot 在 Chain ID 4663 上统一调用 OURS Gateway；合约收取设定的 Bot 手续费，并在路由前复核项目阶段。",
  "product.productAndOperations": "产品与运营",
  "product.productAndOperations2": "募资款用于产品开发与运营",
  "product.projectGraduation": "项目毕业",
  "product.protocolBotSettlement": "平台与Bot结算",
  "product.protocolFee": "协议手续费",
  "product.protocolFeesAreEnforcedByTheCurveAndUniswapV4":
    "协议手续费由 Robinhood Chain 上的 Curve 与 Uniswap v4 Hook 强制收取；符合条件的交易手续费按项目 {{projectPercent}}%、平台 {{platformPercent}}% 分配。Bot 服务费由 TradingGateway 对各 Bot 带来的订单强制收取。",
  "product.quoteAsset": "计价资产",
  "product.raisedAfterContribution": "投入后累计募资",
  "product.ready": "可领取",
  "product.recentTrades": "最近交易",
  "product.recipient": "接收地址",
  "product.records": "全部记录",
  "product.referrerBound": "邀请关系已绑定",
  "product.released": "已释放",
  "product.released2": "累计释放",
  "product.releaseSchedule": "释放明细",
  "product.remaining": "剩余锁定",
  "product.resolvePhaseAndVenue": "判断阶段与场所",
  "product.reviewAndSend": "确认并发送",
  "product.reviewLaunch": "预览发行",
  "product.reviewTrade": "预览交易",
  "product.rewardClaim": "奖励领取",
  "product.rewardsFollowInvitationDataSuccessfulTradingVolumeAndProjectGraduation":
    "奖励依据邀请数据、成功交易量和项目毕业贡献分配。",
  "product.robinhoodAssetRegistry": "ROBINHOOD 资产目录",
  "product.robinhoodChainNativeAssetChainId4663":
    "Robinhood Chain 原生资产 · Chain ID 4663",
  "product.robinhoodChainRoute": "Robinhood Chain 路由",
  "product.robinhoodNativeAsset": "Robinhood 原生资产",
  "product.robinhoodRegistryAsset": "Robinhood 链上资产",
  "product.roundStatus": "募资状态",
  "product.routeAndContract": "路由与合约",
  "product.searchAllRobinhoodAssets": "搜索全部 Robinhood 资产",
  "product.searchSymbolCompanyOrEtf": "搜索股票代码、公司或 ETF",
  "product.searchTokenPairOrAddress": "搜索 Token、交易对或合约地址",
  "product.sell": "卖出",
  "product.sell2": "卖出",
  "product.send": "发送",
  "product.sendAssets": "发送资产",
  "product.sendJoy": "发送 JOY",
  "product.sendToken": "发送 Token",
  "product.sendToken2": "发送 TOKEN",
  "product.settlement": "份额结算",
  "product.skipToContent": "跳至主要内容",
  "product.signInExplanation":
    "签署一条消息以读取你的 OURS 账户资料；此操作不会发起交易，也不会消耗 Gas。",
  "product.signatureCancelled": "已取消签名。",
  "product.signInFailed": "登录失败",
  "product.signInFailedHint": "签名未被接受，可在准备好后重试。",
  "product.signInSucceeded": "已登录 OURS。",
  "product.signInWithWallet": "使用钱包签名登录",
  "product.signedIn": "已登录",
  "product.signedOut": "已退出登录并断开钱包。",
  "product.signingIn": "等待钱包签名…",
  "product.signOut": "退出登录",
  "product.slippageProtectionKeeperFallbackNoRewardPoints":
    "滑点保护 · 执行器兜底 · 不奖励积分",
  "product.snipeTaxExemptWallets": "狙击税豁免地址",
  "product.snipeTaxExemptionHint":
    "使用逗号、空格或换行分隔，最多 32 个地址；发行者和创作者接收地址会由合约自动豁免。",
  "product.stockAssets": "股票资产",
  "product.stocksAndEtfsSynced": "股票与 ETF 已同步",
  "product.stockTokenEligibility": "股票 Token 资格校验",
  "product.storedWithTheLaunchAndShownAcrossDiscoverySurfaces":
    "发行后用于发现页和交易页展示。",
  "product.submitted": "已提交 ✓",
  "product.submitted2": "已提交",
  "product.supply": "总量",
  "product.switchNetwork": "切换网络",
  "product.switchToChain": "切换至 {{chain}}",
  "product.telegram": "Telegram 社区",
  "product.thePeopleWhoBuildTheMarketOwnIt": "建设市场的人，共同拥有它。",
  "product.theRouteIsVerifiedOnchainBeforeExecution":
    "执行前由合约复核内外盘状态与路由。",
  "product.thisRelationshipIsPermanentlyRecordedOnchain":
    "该账户邀请关系已保存，绑定后不可更改。",
  "product.thisRoundAcceptsNativeEthOnlyOnRobinhoodChainIt":
    "本轮仅接受 Robinhood Chain 原生 ETH。募资达到100万美元时对应500万美元估值，随后随累计投入连续增长；达到200万美元时对应1000万美元估值。社区按出资比例共同分配固定20% Token 池。",
  "product.ticker": "代币符号",
  "product.time": "时间",
  "product.toggleTheme": "切换主题",
  "product.token": "选择 TOKEN",
  "product.tokenAllocation": "Token 分配",
  "product.tokenImage": "Token 图片",
  "product.tokenMarket": "Token 市场",
  "product.tokenPositions": "Token 持仓",
  "product.tokenProfile": "Token 信息",
  "product.tokenSent": "发送 Token",
  "product.totalBought": "累计回购",
  "product.totalBurned": "累计销毁",
  "product.totalClaimed": "累计领取",
  "product.totalPoints": "总积分",
  "product.trade": "交易",
  "product.tradeOnCurve": "内盘曲线交易",
  "product.tradeReviewReady": "交易预览已就绪",
  "product.tradeOurs": "交易 OURS",
  "product.trader48Trades": "交易者 · 48笔",
  "product.trades": "交易",
  "product.tradesGraduationBuyback": "交易、毕业、回购推送",
  "product.tradingContract": "交易合约",
  "product.tradingGateway": "交易网关",
  "product.tradingInfrastructure": "交易与开放接入",
  "product.tradingVolume": "交易贡献",
  "product.tradingVolume2": "交易量",
  "product.transactionSubmitted": "交易已提交",
  "product.transfers": "发送",
  "product.treasury": "进入国库",
  "product.treasury2": "国库",
  "product.trending": "热门",
  "product.trigger1000UsdtBuyback": "触发 1,000 USDT 回购",
  "product.triggerTheNextBatch": "触发下一笔回购",
  "product.type": "类型",
  "product.unsignedGatewayTransaction": "生成待签名网关交易",
  "product.valuation": "融资估值",
  "product.valuationAfterContribution": "投入后平台估值",
  "product.valuationFinalTotalRaised5ItIsCalculatedAutomaticallyAnd":
    "当前估值直接使用合约累计募资数据，投入后估值按输入数量与 ETH/USDT 实时行情自动换算。",
  "product.verified": "已验证",
  "product.verified2": "已校验 ✓",
  "product.verifyAndBind": "验证并绑定",
  "product.verifyAsset": "校验资产",
  "product.vestedPrivateTokens": "已解锁私募 Token",
  "product.vesting": "私募释放",
  "product.viewFeeFlywheel": "查看手续费飞轮",
  "product.volume": "交易量",
  "product.waitingForConfirmationThisActionGeneratesZeroPoints":
    "正在等待链上确认，本次行为不会产生积分。",
  "product.wallet": "钱包",
  "product.wallet2": "钱包账户",
  "product.walletAndSigning": "钱包与签名",
  "product.walletAddressCopied": "钱包地址已复制。",
  "product.walletConnected": "钱包已连接",
  "product.walletNotConnected": "未登录",
  "product.website": "项目网站",
  "product.xProfile": "X 账号",
  "product.youPay": "支付",
  "product.yourInviteLink": "你的邀请链接",
  "product.yourToken": "你的 Token",
  "product.yourWalletSubmitsTheLaunchTransactionOursDoesNotCustody":
    "发行交易由你的钱包签名提交，OURS 不托管发行资产。",
  "product.tryAgain": "请重试。",
  "product.remainingBeforeHardCap": "距离硬顶仅剩 ${{amount}}。",
  "product.depositors": "个参与地址",
  "product.fundraisingAccountLimit": "本次投入将超过当前钱包的历史累计上限。",
  "product.fundraisingAmountRequired": "请输入有效的投入数量。",
  "product.fundraisingBelowMinimum": "投入数量低于合约允许的单笔最小值。",
  "product.fundraisingClosedMessage": "募资合约当前不接受投入。",
  "product.fundraisingConfirmed": "投入交易已在链上确认。",
  "product.fundraisingValue": "募资价值",
  "product.fundraisingGlobalLimit": "本次投入将超过剩余的全局募集上限。",
  "product.fundraisingInsufficientBalance":
    "钱包需要保留足够的 ETH 支付投入本金和 Gas。",
  "product.fundraisingNativeOnlyNotice":
    "募资仅使用原生 ETH，成功投入后资金会立即转入合约配置的统一收款地址。",
  "product.fundraisingOnChainIntro":
    "直接读取 Robinhood 主网募资合约的实时额度、累计数据与当前钱包投入情况。",
  "product.fundraisingReadFailed": "无法读取募资合约，请检查 RPC 连接后重试。",
  "product.fundraisingPriceReadFailed":
    "暂时无法获取 ETH/USDT 行情报价，U 价值将在行情恢复后显示。",
  "product.fundraisingStatus": "募资状态",
  "product.fundraisingStatus.cap-reached": "已达募集上限",
  "product.fundraisingStatus.closed": "暂未开放",
  "product.fundraisingStatus.open": "开放中",
  "product.fundraisingSubmitFailed": "链上预检失败，当前合约暂不接受这笔投入。",
  "product.globalRemaining": "全局剩余额度",
  "product.maximumPerWallet": "单钱包累计上限",
  "product.minimumPerDeposit": "单笔最小投入",
  "product.readDirectlyFromContract": "数据直接来自合约",
  "product.receivingAddress": "统一收款地址",
  "product.totalRaised": "累计募集",
  "product.yourContribution": "我的投入",
  "product.launchTogetherGrowTogether": "共同发行，共同成长。",
  "product.exploreOnChainIntro":
    "通过链上实时市场数据发现由 OURS Factory 发射的 Token。",
  "product.launchTokensReadFailed": "暂时无法读取发射台项目。",
  "product.dashboardReadFailed": "暂时无法读取发射台统计数据。",
  "product.unpricedPairs": "未定价交易对",
  "product.imageUploadFailed": "图片上传失败。",
  "product.uploadingImage": "正在上传图片…",
  "product.unsupportedImageType": "请使用 JPEG、PNG、GIF 或 BMP 图片。",
  "product.imageTooLarge": "图片大小不能超过 5 MB。",
  "product.imageUploaded": "图片上传成功，请在钱包中继续。",
  "product.changeImage": "更换图片",
  "product.localImageSelected": "已选择本地预览，尚未上传。",
  "product.checkingLocalImage": "正在检查所选图片…",
  "product.localImageInvalid": "所选文件无法正常展示。",
  "product.checkingImageUrl": "正在检查图片链接是否可以展示…",
  "product.imageUrlValid": "图片加载成功。",
  "product.imageUrlInvalid": "该图片链接无法正常展示。",
  "product.imageRequired": "请选择一张 Token 图片。",
  "product.uploadAndLaunch": "上传并发行",
  "product.retry": "重试",
  "product.noLaunchTokens": "暂无已发射 Token。",
  "product.curve": "联合曲线",
  "product.bondingProgress": "曲线进度",
  "product.createdAt": "创建时间",
  "product.graduatedAt": "毕业时间",
  "product.next": "下一页",
  "product.pagination": "Token 列表分页",
  "product.previous": "上一页",
  "product.quoteReserve": "计价资产储备",
  "product.readyToGraduate": "待毕业",
  "product.terminated": "异常终止",
  "product.invalidTokenAddress": "当前链接中的 Token 地址无效。",
  "product.launchTokenReadFailed": "无法从 Factory 读取该发射项目。",
  "product.noDescription": "该项目发射时未填写介绍。",
  "product.snipeTax": "当前发射保护税",
  "product.insufficientBalance": "钱包余额不足，无法完成本次交易。",
  "product.curveTradingUnavailable": "该 Token 已不支持联合曲线阶段交易。",
  "product.tradeConfirmed": "交易已在链上确认。",
  "product.tradeVenue": "交易场所",
  "product.uniswapV4": "Uniswap v4",
  "product.fetchingQuote": "正在获取报价…",
  "product.uniswapV4TradingUnavailable":
    "该 Token 的毕业 Uniswap v4 池当前不可用。",
  "product.tradeApprovalNotice":
    "ERC-20 交易可能先请求一次授权，再提交交易；最少收到数量按 1% 滑点保护计算。",
  "product.tradeHistoryPending": "交易索引数据待接入",
  "product.holderDataPending": "持有人索引数据待接入",
  "product.logoUrl": "Logo 链接",
  "product.pairTokenApproved": "Factory 已批准",
  "product.factoryApprovalRequired": "需要 Factory 批准",
  "product.registryApprovalRequired": "需要 Revenue Registry 启用该资产",
  "product.pairTokenEconomicsInvalid":
    "Factory 计价参数未配置完整，或与 Token 精度不一致",
  "product.invalidAssetAddress": "请输入有效的合约地址。",
  "product.verifyingAsset": "校验中…",
  "product.assetValidationFailed":
    "无法在 Robinhood Chain 校验该 ERC-20 合约。",
  "product.assetVerifiedAndAdded":
    "已通过 Factory 与 Registry 校验，可在 LP 资产列表使用",
  "product.completeTokenIdentity": "请填写 Token 名称和代币符号。",
  "product.launchConfigurationLoading": "正在加载发射 Factory 配置…",
  "product.launchUnavailable": "当前 Factory 配置暂不允许发行 Token。",
  "product.launchPermissionDenied":
    "当前为非公开发行状态，此钱包不在 Factory 的发行白名单中。",
  "product.launchAssetsLoading": "正在加载可用的 LP 配对资产…",
  "product.dividendAssetsLoading": "正在加载可兑换的分红资产…",
  "product.dividendAssetsFallback":
    "可兑换资产列表读取失败，已默认使用 pairToken {{symbol}}。",
  "product.selectDividendAssetBeforeLaunch":
    "请在高级设置中选择分红资产，或改选不含分红的收益场景。",
  "product.selectAllocationScenario": "请选择一个收益分配场景以配置比例。",
  "product.selectRevenueScenarioBeforeLaunch":
    "请在高级设置中选择一个收益分配场景。",
  "product.invalidMinimumHolding": "请在高级设置中填写有效的最低持仓。",
  "product.launchFactoryReadFailed": "无法读取发射 Factory 配置。",
  "product.pairTokenReadFailed": "无法读取 Factory 已批准的资产，请稍后重试。",
  "product.launchConfirmed": "Token 发射交易已在链上确认。",
  "product.launchIndexing": "项目已在链上确认，行情数据正在同步。",
  "product.onChainDataPending": "链上数据源待接入",
  "product.okxMarketData": "OURS 发射台 K 线 · 内外盘连续行情",
  "product.chartLoading": "正在加载 TradingView 图表…",
  "product.chartIndexing": "成交 K 线正在同步，数据可用后将自动显示。",
  "product.chartNoTrades": "暂无成交，首笔交易后将显示 K 线。",
  "product.chartLoadError": "图表暂时无法加载，请稍后重试。",
  "product.chartAriaLabel": "{{symbol}} TradingView K 线图",
  "product.chartLive": "实时",
  "product.chartConnecting": "连接中",
  "product.chartCached": "缓存行情",
  "product.chartDisconnected": "连接中断",
  "product.activityReadFailed": "暂时无法读取最近交易。",
  "product.holdersReadFailed": "暂时无法读取持币地址。",
  "product.noRecentTrades": "暂无链上交易记录。",
  "product.noHolders": "暂无持币地址。",
  "product.supplyShare": "持仓占比",
  "product.globalCap": "全局募集上限",
  "product.minimumHoldingProjectTokens": "最低持仓 · 项目币数量",
  "product.selectAssetPreview": "请选择资产 · 预览",
  "product.selfRetained": "自留",
  "product.platformTokenOnChainIntro":
    "直接从已配置的 Robinhood Chain 合约读取实时 ERC-20 供应量与钱包余额。",
  "product.platformTokenReadFailed":
    "无法读取平台 Token 合约，请检查 RPC 连接与环境变量配置。",
  "product.copyAddress": "复制地址",
  "product.contractAddressCopied": "合约地址已复制。",
  "product.viewOnRobinhoodExplorer": "在 Robinhood Chain 浏览器中查看",
  "product.totalSupply": "总供应量",
  "product.circulatingSupply": "流通供应量",
  "product.zeroAndDeadAddresses": "零地址 + 销毁地址",
  "product.yourTokenBalance": "我的 Token 余额",
  "product.onChainTokenDetails": "链上 Token 信息",
  "product.tokenName": "Token 名称",
  "product.tokenSymbol": "Token 符号",
  "product.tokenDecimals": "精度",
  "product.latestBlock": "最新读取区块",
  "product.liveContractData": "实时合约数据",
  "product.platformTokenDataSourceNotice":
    "名称、符号、精度、供应量、销毁余额与当前钱包余额每 30 秒通过 RPC 刷新。",
  "product.marketDataUnavailable":
    "该 Token 尚未配置可信行情源，因此价格、市值、成交量和资产法币估值不会使用估算数据。",
  "product.marketDataUnavailableShort": "暂无可信行情源",
  "product.portfolioIndexerUnavailable": "资产索引服务尚未配置",
  "product.buybackDataUnavailable": "暂无回购数据",
  "product.buybackContractNotConfigured":
    "当前未配置回购执行器或资金库合约，因此不会提交交易，也不会展示虚构的执行记录。",
  "product.platformBuybackTitle": "平台 Token 回购与销毁",
  "product.platformBuybackDescription":
    "符合条件的交易手续费按项目 {{projectPercent}}%、平台 {{platformPercent}}% 分配；平台份额中的 {{buybackAndBurnPercent}}% 用于回购销毁、{{liquidityPercent}}% 用于流动性、{{ecosystemPercent}}% 用于生态、{{operationsAndSecurityPercent}}% 用于运营与安全。回购策略预算经 Uniswap v4 买入 OURS，并在同一笔交易中原子销毁。",
  "product.metaDefaultTitle": "OURS.MEME — 社区共建 Meme 发行与交易平台",
  "product.metaDefaultDescription":
    "在 Robinhood Chain 上发行、交易 Meme Token，共建开放透明的链上市场。",
  "product.metaHomeTitle": "OURS.MEME — 社区共建 Meme 发行与交易平台",
  "product.metaHomeDescription":
    "在 Robinhood Chain 上发行、交易 Meme Token；符合条件的交易手续费按项目 {{projectPercent}}%、平台 {{platformPercent}}% 分配。",
  "product.metaFundraisingTitle": "OURS 募资 | OURS.MEME",
  "product.metaFundraisingDescription":
    "查看 OURS 募资进度与认购信息：募资款 {{marketLiquidityPercent}}% 用于市场流动性与 Token 市场建设，{{productAndOperationsPercent}}% 用于产品开发与运营。",
  "product.metaBuybackTitle": "OURS 回购与销毁 | OURS.MEME",
  "product.metaBuybackDescription":
    "查看 OURS 平台 Token 回购与销毁状态；平台所得手续费份额中的 {{buybackAndBurnPercent}}% 用于回购与销毁。",
  "product.metaInfrastructureTitle": "交易基础设施 | OURS.MEME",
  "product.metaInfrastructureDescription":
    "了解 OURS.MEME 的交易基础设施、路由执行与链上手续费结算能力。",
  "product.platformBuybackReadFailed": "暂时无法读取平台回购策略",
  "product.platformBuybackVersion": "策略版本",
  "product.platformBuybackReceiver": "当前版本收款入口",
  "product.platformBuybackStrategy": "回购策略",
  "product.platformBuybackUsdLimit": "链上强制执行的美元额度保护",
  "product.platformBuybackUsdCap": "单笔美元上限",
  "product.platformBuybackExecutionAsset": "本次输入资产",
  "product.platformBuybackQuoteSelected": "报价动态选择",
  "product.platformBuybackExecutionAssetDescription":
    "取得报价后按实际 assetIn 校验预算与上限",
  "product.platformBuybackPendingCollection": "待归集回购预算",
  "product.platformBuybackPendingCollectionDescription":
    "包含 Treasury 已分配预算与本次 FeePool 归集后预计新增预算",
  "product.platformBuybackCollectionAsset": "归集资产",
  "product.platformBuybackFeePoolPending": "FeePool 待归集",
  "product.platformBuybackTreasuryBudget": "Treasury 待领取预算",
  "product.platformBuybackStrategyBudget": "策略可用预算",
  "product.platformBuybackStatus": "策略状态",
  "product.platformBuybackCollect": "归集回购预算",
  "product.platformBuybackNothingToCollect": "暂无可归集预算",
  "product.platformBuybackCollectFirst": "请先归集预算",
  "product.platformBuybackCollectionDescription":
    "归集无需 Owner 或 Operator 权限。系统会在一笔原子交易中先把 FeePool 收入转入 Treasury，再由回购策略领取预算；任一步失败都会整体回滚。",
  "product.platformBuybackCollectionRequired": "待归集",
  "product.platformBuybackCollectionRequiredDescription":
    "FeePool 或 Treasury 中还有待归集的回购预算，请先完成归集，再请求回购报价。",
  "product.platformBuybackCollectionConfirmed": "回购预算归集已确认",
  "product.platformBuybackCollectionConfirmedDescription":
    "回购策略本次新增 {{amount}} {{symbol}}，链上数据正在刷新。",
  "product.platformBuybackCollectionFailed": "回购预算归集失败",
  "product.platformBuybackExecute": "执行 OURS 回购",
  "product.platformBuybackConnectDescription":
    "连接并登录具备平台回购策略执行权限的钱包后，可请求签名报价并发起回购。",
  "product.platformBuybackNoPermissionDescription":
    "当前钱包不是 PLATFORM_V1 回购策略的 Owner 或 Operator，不能执行回购；仍可触发无需权限的预算归集。",
  "product.platformBuybackPaused": "策略已暂停",
  "product.platformBuybackPausedDescription":
    "回购策略或金库预算领取当前已暂停，恢复后才能执行。",
  "product.platformBuybackReadyDescription":
    "执行权限已就绪。钱包确认后将请求短时签名报价；输入资产由报价动态选择，前端会按该资产校验预算、价格、池与额度，完整模拟后再执行回购并销毁。",
  "product.platformBuybackConfirmed": "平台回购已确认",
  "product.platformBuybackConfirmedDescription":
    "本次已回购并销毁 {{amount}} {{symbol}}，链上数据正在刷新。",
  "product.platformBuybackFailed": "平台回购失败",
  "product.invalidRecipientAddress": "请输入有效的接收地址。",
  "product.invalidTransferAmount": "请输入大于 0 且不超过当前余额的数量。",
  "product.tokenTransferFailed": "Token 转账失败",
  "product.vestingContractNotConfigured": "当前未配置释放合约。",
} as const;
